<template>
  <div class="uk-width-1-1">
    <div v-html="this.activeProduct.description"></div>
  </div>
</template>

<script>
import { EventBus } from "../EventBus";
import ProductOverviewPagination from "./ProductOverviewPagination";
import * as functions from "../functions.js";

export default {
  name: "ProductDescription",
  components: { ProductOverviewPagination },
  mounted() {
    EventBus.$on("PRODUCT_CHANGED", (product) => {
      this.activeProduct = product;
      //   this.handleChange(product);
    });
  },
  data() {
    return {
      activeProduct: this.product,
    };
  },
  methods: {},
  props: {
    product: {
      type: Object | Array,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>